/* CCF — sync SEOWill/Giraffly sticky ATC to the theme's main product form.
 * - Main form (variant-selects + quantity) is the single source of truth.
 * - Copies the selected variant's option values into the sticky's own (hidden on mobile)
 *   selects, then lets Giraffly's own change handler update price + In stock / Out of stock.
 * - Never forces both available/unavailable states visible; it only mirrors the
 *   selected variant's real availability using the same inline-display toggle Giraffly uses.
 * - Nonexistent combo (main form shows "Unavailable") => sticky shows Out Of Stock.
 * - Right before a mobile sticky ATC tap (synced mode only) it re-syncs; if the sticky
 *   selection still doesn't match the main form it cancels the sticky add and clicks the
 *   main Add to cart instead (never adds a different variant than the main form shows).
 *   Same fallback when a subscription (selling plan) is selected on the main form.
 * - Adds html.ccf-sticky-synced only after a successful sync on a product page, so the
 *   CSS that hides the sticky Size/Count selects never applies when sync isn't active.
 */
(function () {
  'use strict';
  if (window.__ccfStickyForm) return;
  window.__ccfStickyForm = true;
  if (!/\/products\//.test(location.pathname)) return; // homepage etc: leave Giraffly untouched

  var PHONE_SEL = '.giraffly_phone_Preview_Variants_Select';
  var PC_SEL = '.giraffly_PC_Preview_Variants_Select';
  var product = null;
  var syncTimer = null;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function mainInfo() {
    return document.querySelector('product-info[id^="MainProduct"]') || document.querySelector('product-info');
  }
  function mainForm() {
    var info = mainInfo();
    if (!info) return null;
    var forms = $all('form[id^="product-form-"]', info).filter(function (f) {
      // NB: form.id is shadowed by <input name="id">, so read the attribute.
      return (f.getAttribute('id') || '').indexOf('product-form-installment') !== 0;
    });
    return forms[0] || null;
  }
  function mainVariantId() {
    var f = mainForm();
    var input = f && f.querySelector('input[name="id"]');
    return input ? String(input.value || '') : null; // '' = nonexistent combo, null = no form
  }
  function mainSellingPlan() {
    var f = mainForm();
    if (!f || !f.elements) return '';
    var el = f.elements.namedItem('selling_plan'); // RadioNodeList/element incl. form="" inputs
    return el && el.value ? String(el.value) : '';
  }
  function mainQty() {
    var info = mainInfo();
    var q = info && info.querySelector('.quantity__input, input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function selectedVariantJson(id) {
    var info = mainInfo();
    if (!info) return null;
    var nodes = $all('variant-selects [data-selected-variant]', info);
    for (var i = 0; i < nodes.length; i++) {
      try {
        var v = JSON.parse(nodes[i].textContent || 'null');
        if (v && String(v.id) === id) return v;
      } catch (e) {}
    }
    return null;
  }
  function findVariant(id) {
    if (!id) return null;
    var v = selectedVariantJson(id);
    if (v && v.options) return v;
    if (product && product.variants) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === id) return product.variants[i];
      }
    }
    return v;
  }
  function setStock(available) {
    // Same mechanism Giraffly uses (inline display); no !important overrides.
    $all('.giraffly_Unavailable').forEach(function (el) { el.style.display = available ? 'none' : 'flex'; });
    $all('.giraffly_available').forEach(function (el) { el.style.display = available ? 'flex' : 'none'; });
  }
  function fmtMoney(cents, isCompare) {
    var amt = cents / 100;
    if (typeof window.girafflyReturnAmount === 'function') {
      try { return window.girafflyReturnAmount(amt, !!isCompare); } catch (e) {}
    }
    return '$' + amt.toFixed(2);
  }
  function setPrice(v) {
    var price = Number(v && v.price);
    if (!isFinite(price)) return;
    if (typeof v.price === 'string' && v.price.indexOf('.') > -1) price = Math.round(price * 100); // dollars -> cents
    var cmp = Number(v.compare_at_price);
    if (typeof v.compare_at_price === 'string' && v.compare_at_price.indexOf('.') > -1) cmp = Math.round(cmp * 100);
    var showCmp = isFinite(cmp) && cmp > price;
    $all('.giraffly_price').forEach(function (el) { el.innerHTML = fmtMoney(price); });
    $all('.giraffly_compare_at_price').forEach(function (el) {
      if (showCmp) { el.innerHTML = fmtMoney(cmp, true); el.style.display = ''; }
      else { el.style.display = 'none'; }
    });
  }
  function setSelects(selector, options) {
    var sels = $all(selector);
    var ok = sels.length > 0 && sels.length <= options.length;
    sels.forEach(function (s, i) {
      var want = options[i];
      var match = false;
      for (var k = 0; k < s.options.length; k++) {
        if (s.options[k].value === want) { match = true; break; }
      }
      if (match) s.value = want; else ok = false;
    });
    return ok;
  }
  function selectsMatch(selector, options) {
    var sels = $all(selector);
    if (!sels.length) return false;
    for (var i = 0; i < sels.length; i++) if (sels[i].value !== options[i]) return false;
    return true;
  }
  function syncQty() {
    var n = String(mainQty());
    $all('.giraffly_quantity_text').forEach(function (el) { if (el.value !== n) el.value = n; });
  }
  function bars() { return $all('.giraffly_phoneButtonPreview'); }

  function sync() {
    var b = bars();
    if (!b.length) return false;
    var id = mainVariantId();
    if (id === null) return false;
    syncQty();
    var hasSelects = $all(PHONE_SEL).length > 0;
    if (!hasSelects) { // single-variant product: Giraffly handles it; nothing to hide
      return false;
    }
    var v = findVariant(id);
    if (!v) { // main form says this combination doesn't exist
      b.forEach(function (el) { el.classList.add('ccf-sticky-nocombo'); });
      setStock(false);
      document.documentElement.classList.add('ccf-sticky-synced');
      return true;
    }
    var opts = v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
    var okPhone = setSelects(PHONE_SEL, opts);
    setSelects(PC_SEL, opts);
    if (!okPhone) { // couldn't map: show sticky selects (no synced class) so shopper can still choose
      document.documentElement.classList.remove('ccf-sticky-synced');
      return false;
    }
    // Let Giraffly refresh price / compare-at / image from its own data (no bubbling).
    if (window.jQuery) {
      try { window.jQuery(PHONE_SEL).first().triggerHandler('change'); } catch (e) {}
    }
    // Giraffly's per-select handlers are often not bound, and its body-level change handler
    // reads the sticky selects before this sync updates them, so its price lags one variant.
    // Write the selected variant's price / compare-at ourselves, same format as Giraffly.
    setPrice(v);
    b.forEach(function (el) { el.classList.remove('ccf-sticky-nocombo'); });
    setStock(!!v.available);
    document.documentElement.classList.add('ccf-sticky-synced');
    return true;
  }
  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay || 0);
  }

  // Main form variant change: product-info.js sets input[name=id] and dispatches 'change'.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('input[name="id"]')) {
      var f = mainForm();
      if (f && f.contains(t)) scheduleSync(0);
    } else if (t.matches('.quantity__input, input[name="quantity"]')) {
      var info = mainInfo();
      if (info && info.contains(t)) syncQty();
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target, info = mainInfo();
    if (t && t.matches && t.matches('.quantity__input, input[name="quantity"]') && info && info.contains(t)) syncQty();
  });

  // Mobile sticky ATC tap (capture phase = runs before Giraffly's jQuery click handler).
  // Only when the sticky selects are hidden (synced mode); desktop / fallback untouched.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.giraffly_phoneButtonPreview .PCPreviewbutton');
    if (!btn) return;
    if (!document.documentElement.classList.contains('ccf-sticky-synced')) return;
    var id = mainVariantId();
    if (id === null) return;
    sync();
    var v = findVariant(id);
    var opts = v ? (v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })) : null;
    // Subscription chosen on the main form: Giraffly can't carry it, so use the theme's own submit.
    var subscribe = mainSellingPlan() !== '';
    if (!subscribe && v && v.available && selectsMatch(PHONE_SEL, opts)) return; // Giraffly adds exactly the main-form variant + qty
    e.preventDefault();
    e.stopImmediatePropagation();
    var f = mainForm();
    var submit = f && f.querySelector('[type="submit"][name="add"], .product-form__submit');
    if (v && v.available && submit && !submit.disabled) { submit.click(); return; }
    // Unavailable: bring shopper to the options on the main form.
    var picker = mainInfo() && mainInfo().querySelector('variant-selects');
    if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  // Wait for Giraffly to inject the sticky bar, then do the initial sync.
  function watchForBar() {
    if (bars().length) { scheduleSync(50); return; }
    var mo = new MutationObserver(function () {
      if (bars().length) { mo.disconnect(); scheduleSync(50); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }

  function init() {
    // Only product URLs have a .js endpoint; elsewhere this 404'd and logged a console error.
    if (!/\/products\/[^\/]+\/?$/.test(location.pathname)) { watchForBar(); return; }
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { product = p; if (bars().length) scheduleSync(0); })
      .catch(function () {});
    watchForBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
